<template>
<div class="chapter">
<div class="inner_page">
<p class="copyrightTextH"><i>Frontispiece:</i> Fighter defence of the fleet: an F-14 Tomcat of VF-84 intercepts a Soviet ‘Bear D‘ (Tu-95RTs) snooper over <i>Nimitz</i> during NATO Exercise Teamwork 80.</p>
<div class="top20">
<p class="copyrightText">Copyright © Norman Friedman 2016</p>
<p class="copyrightText1">This edition first published in Great Britain in 2016 by</p>
<p class="copyrightText">Seaforth Publishing,</p>
<p class="copyrightText">An imprint of Pen &amp; Sword Books Ltd,</p>
<p class="copyrightText">47 Church Street,</p>
<p class="copyrightText">Barnsley</p>
<p class="copyrightText">South Yorkshire S70 2AS</p>
<p class="copyrightText1"><a href="http://www.seaforthpublishing.com" target="_blank">www.seaforthpublishing.com</a></p>
<p class="copyrightText">Email: <a href="mailto:info@seaforthpublishing.com">info@seaforthpublishing.com</a></p>
<p class="copyrightText1"><i>British Library Cataloguing in Publication Data</i></p>
<p class="copyrightText">A catalogue record for this book is available from the British Library</p>
<p class="copyrightText1">ISBN 978 1 84832 404 6</p>
<p class="copyrightText1">All rights reserved. No part of this publication may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopying, recording, or any information storage and retrieval system, without prior permission in writing of both the copyright owner and the above publisher.</p>
<p class="copyrightText1">The right of Norman Friedman to be identified as the author of this work has been asserted in accordance with the Copyright, Designs and Patents Act 1988.</p>
<p class="copyrightText1">Typeset and designed by Ian Hughes, Mousemat Design Limited</p>
<p class="copyrightText">Printed and bound in China by 1010 Printing International Ltd</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 00d_copyright.vue?3a85a54c